"use strict";

exports.__esModule = true;
var _PredefinedCommentsScreen = require("./PredefinedCommentsScreen");
Object.keys(_PredefinedCommentsScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PredefinedCommentsScreen[key]) return;
  exports[key] = _PredefinedCommentsScreen[key];
});
var _PredefinedCommentsRoutes = require("./PredefinedCommentsRoutes");
Object.keys(_PredefinedCommentsRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PredefinedCommentsRoutes[key]) return;
  exports[key] = _PredefinedCommentsRoutes[key];
});
var _PredefinedCommentsContext = require("./PredefinedCommentsContext");
Object.keys(_PredefinedCommentsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PredefinedCommentsContext[key]) return;
  exports[key] = _PredefinedCommentsContext[key];
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  exports[key] = _types[key];
});